import PortableApplianceTestingForm from './PortableApplianceTestingForm';
import PortableApplianceTestingPDF from './PortableApplianceTestingPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF, buildVerificationPayload } from './transform';

export default {
  Form: PortableApplianceTestingForm,
  PDF: PortableApplianceTestingPDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF,
  buildVerificationPayload
};